import base from './base'

let controller = 'permission'
let action = null

const BasicPermission = {
  async listBasicPermissions (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    querys.isPrivate = (query.isPrivate !== null && query.isPrivate !== undefined) ? query.isPrivate ? true : false : null
    querys.needCert = (query.needCert !== null && query.needCert !== undefined) ? query.needCert ? true : false : null
    querys.needMultiFactor = (query.needMultiFactor !== null && query.needMultiFactor !== undefined) ? query.needMultiFactor ? true : false : null
    action = 'ListPermissions'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addBasicPermission (request) {
    let model = {
      name: request.name || null,
      controller: request.controller || null,
      action: request.action || null,
      isPrivate: request.isPrivate || false,
      needCert: request.needCert || false,
      needMultiFactor: request.needMultiFactor || false,
      ownedByCityId: request.ownedByCityId || null,
      ownedByIndustryId: request.ownedByIndustryId || null
    }
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async updateBasicPermission (request) {
    let model = {
      id: request.id || request.tid || null,
      name: request.name || null,
      controller: request.controller || null,
      action: request.action || null,
      isPrivate: request.isPrivate || false,
      needCert: request.needCert || false,
      needMultiFactor: request.needMultiFactor || false,
      ownedByCityId: request.ownedByCityId || null,
      ownedByIndustryId: request.ownedByIndustryId || null
    }
    if (!model.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${model.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async deleteBasicPermission (permissionId) {
    if (!permissionId) {
      throw new Error('PermissionId为空')
    }
    action = `Delete/${permissionId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async listRolePermissions (roleId) {
    if (!roleId) {
      throw new Error('角色为空')
    }
    action = `ListRolePermissions/${roleId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async addPermissionToRole (permissionId, roleId) {
    if (!roleId || !permissionId) {
      throw new Error('角色或权限为空')
    }
    action = `AddPermissionToRole`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        roleId: roleId,
        permissionId: permissionId
      }
    }
    return base.request(reqModel)
  },

  async removePermissionFromRole (permissionId, roleId) {
    if (!roleId || !permissionId) {
      throw new Error('角色或权限为空')
    }
    action = `RemovePermissionFromRole`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        roleId: roleId,
        permissionId: permissionId
      }
    }
    return base.request(reqModel)
  },

  async updateRolePermissions (roleId, permissionIds) {
    console.log(roleId, permissionIds)
    if (!roleId) {
      throw new Error('角色为空')
    }
    action = `UpdateRolePermissions`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        roleId: roleId,
        permissionIds: permissionIds
      }
    }
    return base.request(reqModel)
  }
}

export default BasicPermission